import { render } from "./InquiryBoadingPass.vue?vue&type=template&id=bc71ec78"
import script from "./InquiryBoadingPass.vue?vue&type=script&lang=js"
export * from "./InquiryBoadingPass.vue?vue&type=script&lang=js"

import "./InquiryBoadingPass.vue?vue&type=style&index=0&id=bc71ec78&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__